import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './MainPanelHeader.module.css';

const MainPanelHeader = props => {
  const {
    rootClassName,
    className,
    children,
    sortByComponent,
    isSortByActive,
    listingsAreLoaded,
    resultsCount,
    searchInProgress = false,
    noResultsInfo,
    isSecondaryFiltersOpen = false,
    onCloseFilters,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        <div className={css.filtersLeft}>
          {children}
        </div>
        <div className={css.sortRight}>
          {isSecondaryFiltersOpen ? (
            <button
              className={css.closeButton}
              type="button"
              onClick={onCloseFilters}
              aria-label="Close filters"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="11" stroke="#14142A" strokeWidth="1.5"/>
                <path d="M8 8L16 16M16 8L8 16" stroke="#14142A" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </button>
          ) : (
            <>
              {isSortByActive ? (
                <div className={css.sortByWrapper}>
                  {sortByComponent}
                </div>
              ) : null}
              <span className={css.resultsCount}>
                {searchInProgress ? (
                  <FormattedMessage id="MainPanelHeader.loadingResults" />
                ) : (
                  <FormattedMessage
                    id="MainPanelHeader.foundResults"
                    values={{ count: resultsCount }}
                  />
                )}
              </span>
            </>
          )}
        </div>
      </div>

      {noResultsInfo ? noResultsInfo : null}
    </div>
  );
};

export default MainPanelHeader;
